import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import axios from 'axios';
import { useState, useSyncExternalStore } from 'react';
import { goToLogin, reloadPage } from 'src/utils/pageNavigation';
import { SelectedCompanyForbiddenStore, selectedCompanyForbiddenStore } from 'src/utils/selectedCompanyForbidden';

const SESSION_PATH = '/api/v2/session';

type Props = {
  store?: SelectedCompanyForbiddenStore;
};

// 切替先の会社への権限が外れたとき（log_web_issues#367）に、自社へ切り替えて再読み込みさせる。
// LicenseProvider は route ごとにマウントされるので、その外（App）に 1 つだけ置き、自社の ID はセッション API から取る
export default function SelectedCompanyForbiddenDialog({ store = selectedCompanyForbiddenStore }: Props) {
  const open = useSyncExternalStore(store.subscribe, store.getSnapshot);
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);

  const switchToOwnCompany = async () => {
    setPending(true);
    setFailed(false);
    try {
      const { data } = await axios.get<{ company_id: number }>(SESSION_PATH);
      await axios.put(SESSION_PATH, { selected_company_id: data.company_id });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 401) {
        goToLogin();
      } else {
        // 失敗したまま再読み込みすると、権限の無い会社のまま同じダイアログに戻るので、ここで止めて再試行させる
        setFailed(true);
      }
      // 未保存変更の確認で離脱がキャンセルされたとき、ボタンを押せなくならないように戻す
      setPending(false);
      return;
    }
    reloadPage();
    // 同上
    setPending(false);
  };

  return (
    <Dialog open={open} disableEscapeKeyDown>
      <DialogTitle>選択中の会社の権限がなくなりました</DialogTitle>
      <DialogContent>
        <DialogContentText>
          この会社を表示する権限が外れたため、操作を続けられません。自社に切り替えて画面を読み込み直します。
          ほかの会社を選ぶ場合は、読み込み直したあとにヘッダで選んでください。
        </DialogContentText>
        {failed && <Alert severity="error">会社を切り替えられませんでした。もう一度お試しください</Alert>}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" disabled={pending} onClick={() => void switchToOwnCompany()}>
          自社に切り替えて再読み込み
        </Button>
      </DialogActions>
    </Dialog>
  );
}
